import { GET_WORKERSPROFILE } from './endpoints';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WorkerProfileService extends BaseService{
  constructor(http: HttpClient) {
    super(http);
}

getWorkerprofileId(): Observable<any> {
    const url = GET_WORKERSPROFILE;
    // const url = GET_WORKERSPROFILE + '/' + id;
    return this.getRequest(url, null);
}
update(id: number, updateParams: any): Observable<any> {
  const url =id? GET_WORKERSPROFILE + '/' + id:GET_WORKERSPROFILE;
  const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
  };
  return this.putRequest(url, updateParams, options);
}
save(data){
  const url = GET_WORKERSPROFILE;
  const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
  };
  return  this.postRequest(url,data,options);
}
}
